
import { userStore, UserService } from '@/store'
import { Component } from 'vue-property-decorator'
import { CitizenPassportVue } from '@/citizen-passport/base'
import { NavigationButtons, RrPerson } from '@/commons/types'
import { BASE_PATH } from '@/citizen-passport/constants/router'
import AppNavigation from '@/commons/components/core/AppNavigation.vue'
import { ApplicantButtonUtils } from '@/commons/utils/applicant.buttons'
import LoadingSpinner from '@/commons/components/core/LoadingSpinner.vue'
import ApplicantSelectionHeader from '@/commons/components/applicants/ApplicantSelectionHeader.vue'

@Component({
    components: {
        LoadingSpinner,
        AppNavigation,
        ApplicantSelectionHeader
    }
})
export default class CitizenPassportApplicants extends CitizenPassportVue {
    get rrPerson (): RrPerson | null {
        return userStore.rrPerson
    }

    get underCareAndWardens (): Array<RrPerson> {
        return userStore.underCareAndWardens
    }

    get isLoading (): boolean {
        return !userStore.isValidRrInfo
    }

    created (): void {
        document.title = this.$tc('metadata.applicant')
        UserService.fetchUserRRInfo()
    }

    get navigationButtons (): Array<NavigationButtons> {
        return ApplicantButtonUtils.generateApplicantNavigationButtons(
            this,
            'citizenPassportApplicants.myselfButtonText',
            'citizenPassportApplicants.otherPersonButtonText',
            BASE_PATH,
            this.rrPerson,
            this.underCareAndWardens
        )
    }
}
